import { useState } from 'react';
import type { ReactNode } from 'react';
import { Icon } from './Icon';

export function Accordion({ items }: { items: { id: string; title: string; body: ReactNode }[] }) {
  const [open, setOpen] = useState<string | null>(null);
  return (
    <div
      style={{ border: '1px solid var(--border)', borderRadius: 'var(--r-lg)', overflow: 'hidden' }}
    >
      {items.map((it, i) => {
        const on = open === it.id;
        return (
          <div key={it.id} style={{ borderTop: i ? '1px solid var(--border)' : 'none' }}>
            <button
              aria-expanded={on}
              onClick={() => setOpen(on ? null : it.id)}
              style={{
                width: '100%',
                height: 44,
                padding: '0 12px',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                border: 'none',
                background: on ? 'var(--bg-2)' : 'transparent',
                cursor: 'pointer',
                font: '500 14px/20px var(--font-ui)',
                color: 'var(--text)',
                textAlign: 'left',
              }}
            >
              <span
                style={{
                  display: 'grid',
                  color: 'var(--dim)',
                  transform: on ? 'rotate(90deg)' : 'none',
                  transition: 'transform var(--dur-2)',
                }}
              >
                <Icon name="chevron-right" size={16} />
              </span>
              <span style={{ flex: 1 }}>{it.title}</span>
            </button>
            {on && <div style={{ padding: 12 }}>{it.body}</div>}
          </div>
        );
      })}
    </div>
  );
}
